import React, {FC, useRef} from "react"
import IconButton from "@irati/ui/src/Button/IconButton"
import {IconTypes} from "@irati/ui/src/Icon"
import {walletTracking} from "@irati-tracking/wallet"
import CashbackModal from "./index"

interface Props {}

const TriggerCashbackModal: FC<Props> = () => {
  const cashbackInfoModal = useRef(null)
  const handleModal = () => {
    cashbackInfoModal?.current?.show()
  }

  // Prevent default action of the button
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    handleModal()
    walletTracking.clickCashbackCTA("tooltip", "cashback_wallet")
    e.stopPropagation()
    e.preventDefault()
  }

  return (
    <div>
      <IconButton onClick={handleClick} icon={IconTypes.circleQuestion} extraLarge />
      <CashbackModal ref={cashbackInfoModal} />
    </div>
  )
}

export default TriggerCashbackModal
